'use client';

import React, { memo, useEffect } from 'react';
import { colors } from "@argo/principles";
import { MyWalletIcon } from "@argo/ui-elements";
import styled from '@emotion/styled';
import triggerImpression from '../../../analytics/react/triggerImpression';
import useAnalytics from '../../../analytics/react/useAnalytics';
const {
  action
} = colors;
const MyWalletBadge = styled('span')`
  display: inline-block;
  min-width: 10px;
  padding: 6px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  color: #000000;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  background-color: ${action.gold};
  border-radius: 13px;
  position: absolute;
  left: 60%;
  top: 15%;
`;
const MyWalletContent = ({
  hasNewTradeIn = false,
  onWalletIconClick = () => {},
  totalWalletNotifs = 0,
  walletPopoverContainer
}) => {
  const analytics = useAnalytics();
  const handleKeyDown = e => {
    if (['Enter', ' '].includes(e.key)) {
      onWalletIconClick(e);
    }
  };
  useEffect(() => {
    if (hasNewTradeIn) {
      triggerImpression(analytics, dataLayer => ({
        googleAnalytics: {
          props: {
            event: 'analytics_event',
            eventElement: 'my-wallet',
            eventAction: 'impression',
            eventResult: 'trade-in-indicator',
            eventNonInteractive: false,
            eventData: {
              vehicle: {}
            }
          }
        }
      }));
    }
  }, [hasNewTradeIn]);
  return React.createElement("div", {
    onClick: onWalletIconClick,
    role: "button",
    tabindex: "0",
    "aria-label": "My Wallet",
    onKeyDown: handleKeyDown
  }, React.createElement(MyWalletIcon, {
    color: "#FFFFFF"
  }), totalWalletNotifs > 0 && React.createElement(MyWalletBadge, null, totalWalletNotifs), walletPopoverContainer);
};
export default MyWalletContent;